/**
 * @generated SignedSource<<be48f63110c0bb1468f51f7e39770552>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type VaultListFilter = "ALL" | "COMPLIMENTARY" | "%future added value";
export type vaultSearchQuery$variables = {
  filter: VaultListFilter;
  query: string;
};
export type vaultSearchQuery$data = {
  readonly vaultSearch: ReadonlyArray<{
    readonly complimentaryUntil: any | null | undefined;
    readonly grantedBy: string | null | undefined;
    readonly identifier: string;
    readonly isComplimentary: boolean;
    readonly jurisdiction: string;
    readonly name: string;
    readonly ownerEmail: string | null | undefined;
    readonly planName: string | null | undefined;
    readonly subscriptionStatus: string | null | undefined;
    readonly vaultId: any;
  }>;
};
export type vaultSearchQuery = {
  response: vaultSearchQuery$data;
  variables: vaultSearchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "query"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
      },
      {
        "kind": "Variable",
        "name": "query",
        "variableName": "query"
      }
    ],
    "concreteType": "VaultSearchResult",
    "kind": "LinkedField",
    "name": "vaultSearch",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "vaultId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "identifier",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "jurisdiction",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ownerEmail",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "planName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "subscriptionStatus",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isComplimentary",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "complimentaryUntil",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "grantedBy",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "vaultSearchQuery",
    "selections": (v2/*: any*/),
    "type": "AdminQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "vaultSearchQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "3cb3192edba51690611b48bd63de22eb",
    "id": null,
    "metadata": {},
    "name": "vaultSearchQuery",
    "operationKind": "query",
    "text": "query vaultSearchQuery(\n  $query: String!\n  $filter: VaultListFilter!\n) {\n  vaultSearch(query: $query, filter: $filter) {\n    vaultId\n    name\n    identifier\n    jurisdiction\n    ownerEmail\n    planName\n    subscriptionStatus\n    isComplimentary\n    complimentaryUntil\n    grantedBy\n  }\n}\n"
  }
};
})();

(node as any).hash = "000ca2e5045a53c2d3e2ac9d481650e4";

export default node;
